var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookmarkGradient({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 25,
    viewBox: "0 0 21 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6177 0H2.46986C1.15474 0 0 0.971841 0 2.12218V23.5798C0 23.9648 0.119306 24.2858 0.311588 24.5337C0.541538 24.8301 0.911794 25 1.30883 24.9999C1.6842 24.9999 2.08386 24.8498 2.45293 24.5666L9.67746 19.0566C9.90058 18.8854 10.2211 18.7873 10.5543 18.7873C10.8874 18.7873 11.2073 18.8854 11.4311 19.0571L18.6315 24.5658C19.0018 24.8498 19.3739 25 19.7487 25C20.3823 25 21 24.5609 21 23.5799V2.12218C21 0.971841 19.9328 0 18.6177 0Z",
    fill: "url(#paint0_linear_4314_134)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4314_134",
    x1: -3.52917,
    y1: 51.875,
    x2: -26.0644,
    y2: 35.911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D38F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E827D9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkGradient);
export default __webpack_public_path__ + "static/media/bookmark_gradient.0f7a157a253efc2c3c6c252a8e06fe01.svg";
export { ForwardRef as ReactComponent };